import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const addTaxRate = ({ currentTarget }) => {
    const selector = currentTarget.getAttribute('data-template');
    const placeholder = currentTarget.getAttribute('data-child-placeholder');
    const template = $(selector)[0].content.children[0].cloneNode(true);
    const randomIndex = new Date().getTime();

    template.querySelectorAll('input').forEach((element) => {
      element.id = element.id.replace(placeholder, randomIndex);
      element.name = element.name.replace(placeholder, randomIndex);
    });

    $(currentTarget).parents('table').find('tbody').append(template);
    $(template).find('td:first input').focus();
  };
  $(document).on('click', '[data-button="sales-tax--add-tax-rate"]', addTaxRate);

  const removeTaxRate = ({ currentTarget }) => {
    const $tr = $(currentTarget).parents('tr');
    const $destroy = $tr.find('[data-tax-rate-field="destroy"]');

    if ($destroy.length) {
      $destroy.val('1');
      $tr.find('.field').prop('disabled', true);
      $tr.hide();
    } else {
      $tr.remove();
    }
  };
  $(document).on('click', '[data-button="sales-tax--remove-tax-rate"]', removeTaxRate);

  const calculateTotalSalesTaxRate = () => {
    let total = 0.0;
    $('.field--rate:visible').each((_index, e) => {
      total += parseFloat($(e).val()) || 0;
    });
    $('.tax-rates-table__total').text(total.toFixed(3) * 1);
  };

  $(document).on('keypress', '.tax-rates-table__item-td--rate', (e) => {
    const oldVal = e.target.value;
    const newVal = `${oldVal}${String.fromCharCode(e.which)}`;
    if (newVal.split('.').length > 1) {
      const decimals = newVal.split('.')[1].length;
      if (decimals > 3) {
        return false;
      }
    }
  });

  $(document).on('change keyup paste input', '.field--rate', (e) => {
    calculateTotalSalesTaxRate();
  });

  $(document).on('click', '.tax-rates-table__remove-tax-rate-link', (e) => {
    calculateTotalSalesTaxRate();
  });
});
